  <div class="login-root vh-100">
    <!-- Fullscreen Background Image -->
    <img :src="$clientImage.onboarding" class="bg-image" alt="Background" />

    <!-- Edge-to-edge Glass Shell -->
    <div class="glass-shell">
      <!-- Inset Image -->
      <div class="image-frame">
        <img
          :src="$clientImage.onboarding"
          class="frame-image"
          alt="Inset Background"
        />
      </div>

      

      <!-- RIGHT: Login (CENTERED) -->
      <div class="login-right">
        <div class="login-card">
          <div class="text-center mb-3 p-0">
            <img :src="$clientLogo" class="img-fluid" width="230" />
          </div>

          <h5 class="mb-3 text-xs text-center p-0">{{ title }}</h5>

          <form @submit.prevent="submitForm">
            <slot name="form-content"></slot>

            <button
              v-if="show_default_submit_button"
              type="submit"
              class="btn btn-primary-dark shadow w-100 mb-3"
              :disabled="verification_running"
            >
              {{ submit_button_text }}
            </button>

            <slot name="custom-button"></slot>
            <slot name="signup-content"></slot>
          </form>
        </div>
      </div>
    </div>
  </div>